import { useHistory } from "react-router-dom";
import { TransferBalance, TransferType } from "./types";
import queryString from "qs";

export const PATH_TRANSFER = "/member/transfer";

export const PATH_TRANSFER_ADD_BANK_ACCOUNT =
  "/member/transfer/add-bank-account";

export const useGoToTransfer = () => {
  const history = useHistory();

  return (params: { balance?: TransferBalance; type?: TransferType }) => {
    const search = queryString.stringify(params);

    history.push({
      pathname: PATH_TRANSFER,
      search: `?${search}`
    });
  };
};
